module.exports = __webpack_public_path__ + "img/eagle.be5030ca.webp";